module.exports = __webpack_public_path__ + "media/images/patterns/triangular-356ffe5155920af451ffe55dba6f74b7.png";